export const locale = {
  lang: "fr-CA",
  data: {
    RELEASENOTE: {
      TITLE: "Note de mise à jour",
    },
  },
};
